import React from 'react';
import './HomeAbout.css';

import img from '../../../assets/SK College.jpg'

function HomeAbout() {
  return (
    <section className="home-about-section">
      <div className="home-about-container">
        
        {/* --- Centered Main Title --- */}
        <div className="home-about-header">
          <h4 className="home-about-subtitle">Our Foundation</h4>
          <h2>About SK College</h2>
        </div>

        {/* --- Main Content Layout: Image + Text --- */}
        <div className="home-about-split-layout">
          
          {/* --- Left Column: College Image --- */}
          <div className="home-about-image-column">
            <img 
              src={img} 
              alt="SK College Campus" 
              className="home-about-college-image"
            />
          </div>
          
          {/* --- Right Column: About College Text --- */}
          <div className="home-about-text-column">
            <h3>A Legacy of Empowerment Since 2021</h3>
            <p className="home-about-lead-text">
              Established in 2021, SK College has become a leading institution in western Rajasthan, founded on a powerful mission: to provide an exceptional and supportive educational environment, especially for students with disabilities. We believe that education is a right, not a privilege, which is why we proudly offer <strong>free-of-cost B.A. programs.</strong>
            </p>
            <p className="home-about-secondary-text">
              Our core philosophy is to ensure that no student feels discouraged or left behind. We derive our strength from a visionary team of educators who are dedicated to quality, innovation, and a hands-on learning process. At SK College, we are not just teaching subjects; we are shaping confident, capable, and resilient individuals ready to build a stronger tomorrow.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default HomeAbout;